import React, { createContext, useContext, useState } from 'react';
import useChatPrefs from '../pages/(All) messenger/hooks/useChatPrefs';

const MessengerContext = createContext();

export const useMessenger = () => {
  const context = useContext(MessengerContext);
  if (!context) {
    throw new Error('useMessenger must be used within MessengerProvider');
  }
  return context;
};

export const MessengerProvider = ({ children }) => {
  const [conversations, setConversations] = useState([]);
  const [messages, setMessages] = useState({});
  const [onlineUsers, setOnlineUsers] = useState(new Set());
  const [currentUser, setCurrentUser] = useState(null);
  const [socket, setSocket] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [employeeProfilePics, setEmployeeProfilePics] = useState({});
  const [selectedUser, setSelectedUser] = useState(null);
  // Set by MessengerPage.jsx on mount/unmount so other always-mounted UI
  // (the Mini Chat Dock) knows the full inbox is currently open and can hide
  // itself instead of showing a second, redundant chat surface.
  const [isMessengerPageOpen, setIsMessengerPageOpen] = useState(false);

  // Lifted here (rather than instantiated separately by MessengerPage and
  // the Mini Chat Dock) so starring/pinning/aliasing a chat from EITHER
  // surface is instantly reflected in the other — both read the same
  // in-memory `prefs` state, not just the same localStorage key.
  const chatPrefs = useChatPrefs(currentUser?.infinityCode);

  return (
    <MessengerContext.Provider value={{
      conversations,
      setConversations,
      messages,
      setMessages,
      onlineUsers,
      setOnlineUsers,
      currentUser,
      setCurrentUser,
      socket,
      setSocket,
      isConnected,
      setIsConnected,
      employeeProfilePics,
      setEmployeeProfilePics,
      selectedUser,
      setSelectedUser,
      isMessengerPageOpen,
      setIsMessengerPageOpen,
      chatPrefs,
    }}>
      {children}
    </MessengerContext.Provider>
  );
};